module.exports = "/assets/data/dd8bab6d6fb7494f3c656c080306066b-RM6.data.json";